// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xw0j6","col":"styles_col__2oWWT","actions":"styles_actions__1C8FT","conflict":"styles_conflict__1bvqa"};